import { gql } from '@apollo/client';

/**
 * Read-only review payload behind an external sign-off token — the form's
 * version content + the submitted responses to render read-only, the
 * co-brand owner name, the score summary (already gated server-side by the
 * form's reviewer-visibility toggles), and whether it's already signed off.
 */
export const FORM_SIGNOFF_REVIEW = gql`
  query formSignoffReview($token: String!) {
    formSignoffReview(token: $token) {
      alreadyCompleted
      reviewerName
      reviewerTitle
      ownerName
      acceptLabel
      declineLabel
      canComment
      canOverallComment
      acknowledgementOnly
      result {
        id
        formDocumentId
        formName
        versionContent
        responses
        submittedAt
        score
        scoreMax
        scorePercent
        flaggedAnswerCount
        fillerEmail
        submittedBy {
          name
        }
      }
    }
  }
`;

/** Record the external reviewer's verdict via the token. */
export const SIGN_OFF_FORM_RESULT_EXTERNAL = gql`
  mutation signOffFormResultExternal($input: SignOffExternalInput!) {
    signOffFormResultExternal(input: $input) {
      success
      message
    }
  }
`;

export interface SignoffReviewResult {
  id: string | null;
  formDocumentId: string | null;
  formName: string | null;
  versionContent: unknown;
  responses: Record<string, unknown> | null;
  submittedAt: string | null;
  score: number | null;
  scoreMax: number | null;
  scorePercent: number | null;
  flaggedAnswerCount: number | null;
  fillerEmail: string | null;
  submittedBy: { name: string | null } | null;
}

export interface FormSignoffReview {
  alreadyCompleted: boolean;
  reviewerName: string | null;
  reviewerTitle: string | null;
  ownerName: string | null;
  acceptLabel: string;
  declineLabel: string;
  canComment: boolean;
  canOverallComment: boolean;
  acknowledgementOnly: boolean;
  result: SignoffReviewResult | null;
}
